import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
    FiBookOpen,
    FiClock,
    FiCheckCircle,
    FiSearch,
    FiLayers,
    FiTrendingUp,
} from "react-icons/fi";
import { ENDPOINTS as LMS_ENDPOINTS } from "../Utils/Endpoints";
import { API_BASE } from "../../../api";
import { getSessionUserId } from "../../../utils/SessionUser";

const MisCarreras = () => {
    const navigate = useNavigate();

    const [carreras, setCarreras] = useState([]);
    const [tab, setTab] = useState("todo");
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const [resumen, setResumen] = useState({
        totalMatriculadas: 0,
        enCurso: 0,
        completadas: 0
    });

    const SERVER_URL = API_BASE.replace(/\/api\/?$/, "");

    useEffect(() => {
        const loadData = async () => {
            const idUsuarioSesion = getSessionUserId();
            if (!idUsuarioSesion) {
                setCarreras([]);
                return;
            }

            setLoading(true);
            try {
                const res = await axios.get(LMS_ENDPOINTS.misCarrerasHistorico(idUsuarioSesion));
                const data = res.data || {};

                setCarreras(data.carreras || data.Carreras || []);
                setResumen(data.resumen || data.Resumen || {
                    totalMatriculadas: 0,
                    enCurso: 0,
                    completadas: 0
                });

            } catch (error) {
                console.error("Error al cargar mis carreras:", error);
                setCarreras([]);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);

    const filtrados = (carreras || [])
        .filter((c) => {
            // 1. Filtro de Tab
            if (tab !== "todo") {
                if (tab === "completada") {
                    if ((c.progreso || c.Progreso || 0) < 100) return false;
                } else if (tab === "en-curso") {
                    if ((c.progreso || c.Progreso || 0) === 100) return false;
                }
            }

            // 2. Filtro de Búsqueda
            if (searchTerm && !(c.nombre || "").toLowerCase().includes(searchTerm.toLowerCase())) return false;

            return true;
        })
        .sort((a, b) => {
            const getPriority = (c) => {
                const p = c.progreso || c.Progreso || 0;
                if (p > 0 && p < 100) return 1; // En curso primero
                if (p === 0) return 2;          // Sin empezar después
                return 3;                       // Completadas al final
            };
            return getPriority(a) - getPriority(b);
        });

    const handleOpenCarrera = (carrera) => {
        const id = carrera.idCarrera || carrera.IdCarrera;
        if (!id) return;
        navigate(`/menu/lms/carrera-estudiante/${id}`);
    };

    return (
        <div className="panel-sigma-main">
            <div className="profile-header-title">
                <h1>Mis carreras</h1>
            </div>

            {/* Estadísticas */}
            <div className="stats-grid stats-grid-wrap">
                <div className="stat-card">
                    <div className="stat-icon professional" style={{ backgroundColor: 'var(--color-primary)' }}>
                        <FiLayers />
                    </div>
                    <div>
                        <p className="stat-label">Carreras matriculadas</p>
                        <p className="stat-value">{resumen.totalMatriculadas}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon professional" style={{ backgroundColor: 'var(--color-primary)' }}>
                        <FiClock />
                    </div>
                    <div>
                        <p className="stat-label">En curso</p>
                        <p className="stat-value">{resumen.enCurso}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon professional" style={{ backgroundColor: 'var(--color-primary)' }}>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="stat-label">Completadas</p>
                        <p className="stat-value">{resumen.completadas}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon professional" style={{ backgroundColor: 'var(--color-primary)' }}>
                        <FiTrendingUp />
                    </div>
                    <div>
                        <p className="stat-label">Promedio de avance</p>
                        <p className="stat-value">
                            {carreras.length > 0
                                ? `${Math.round(carreras.reduce((acc, c) => acc + (c.progreso || 0), 0) / carreras.length)}%`
                                : "0%"}
                        </p>
                    </div>
                </div>
            </div>

            {/* UI de Búsqueda y Tabs */}
            <div style={{ marginBottom: '2rem', filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.05))' }}>
                <div style={{
                    display: 'flex',
                    width: '100%',
                    backgroundColor: '#f1f5f9',
                    borderRadius: '12px 12px 0 0',
                    overflow: 'hidden',
                    padding: '0.4rem',
                    gap: '0.5rem',
                    border: '1px solid #e2e8f0',
                    borderBottom: 'none'
                }}>
                    {['todo', 'en-curso', 'completada'].map((option) => (
                        <div
                            key={option}
                            onClick={() => setTab(option)}
                            style={{
                                flex: 1,
                                textAlign: 'center',
                                padding: '0.4rem 0',
                                fontSize: '0.9rem',
                                fontWeight: tab === option ? 700 : 500,
                                color: tab === option ? 'var(--color-primary-dark)' : '#64748b',
                                backgroundColor: tab === option ? '#ffffff' : 'transparent',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                userSelect: 'none',
                                textTransform: 'capitalize',
                                boxShadow: tab === option ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
                            }}
                        >
                            {option.replace('-', ' ')}
                        </div>
                    ))}
                </div>

                <div style={{
                    background: '#ffffff',
                    border: '1px solid #e2e8f0',
                    borderTop: 'none',
                    borderRadius: '0 0 12px 12px',
                    padding: '0.8rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '999px',
                        padding: '0.4rem 1rem',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                    }}>
                        <FiSearch style={{ color: 'var(--color-primary-dark)', marginRight: '0.6rem', fontSize: '1rem' }} />
                        <input
                            type="text"
                            placeholder="Buscar mis carreras..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ border: 'none', outline: 'none', background: 'transparent', width: '100%', fontSize: '0.9rem', color: '#1e293b' }}
                        />
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="catalog-loading">Cargando carreras...</div>
            ) : (
                <div className="courses-grid fixed-cards">
                    {filtrados.length === 0 ? (
                        <div
                            style={{
                                gridColumn: "1 / -1",
                                textAlign: "center",
                                padding: "3rem",
                                color: "#94a3b8",
                            }}
                        >
                            No se encontraron carreras.
                        </div>
                    ) : (
                        filtrados.map((carrera, index) => {
                            const imagePath = carrera.urlImagen || carrera.UrlImagen;
                            const hasImage = !!imagePath;
                            const imageUrl = hasImage
                                ? (imagePath.startsWith('http') ? imagePath : `${SERVER_URL}${imagePath}`)
                                : null;

                            const itemKey = carrera.idCarreraEstudiante || carrera.IdCarreraEstudiante || index;

                            const progreso = carrera.progreso || carrera.Progreso || 0;
                            const statusVisuals = (() => {
                                if (progreso === 100) return { bg: '#15803d', icon: <FiCheckCircle />, label: 'Completada' };
                                if (progreso > 0) return { bg: '#0369a1', icon: <FiClock />, label: 'En curso' };
                                return { bg: '#64748b', icon: <FiLayers />, label: 'Sin empezar' };
                            })();

                            return (
                                <article
                                    key={itemKey}
                                    className="course-card fixed-card"
                                    style={{
                                        border: `1px solid ${statusVisuals.bg}`,
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    <div className="course-thumb" style={{ padding: 0, position: 'relative' }}>
                                        {hasImage ? (
                                            <img
                                                src={imageUrl}
                                                alt={carrera.nombre}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "fill",
                                                    display: "block",
                                                }}
                                            />
                                        ) : (
                                            <div className="course-thumb course-thumb-default" style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#e2e8f0', color: '#94a3b8' }}>
                                                <FiLayers size={48} />
                                            </div>
                                        )}

                                        {/* Triángulo de estatus */}
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            width: '60px',
                                            height: '60px',
                                            zIndex: 5,
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                width: 0,
                                                height: 0,
                                                borderStyle: 'solid',
                                                borderWidth: '0 60px 60px 0',
                                                borderColor: `transparent ${statusVisuals.bg} transparent transparent`,
                                                filter: 'drop-shadow(-1px 1px 2px rgba(0,0,0,0.2))'
                                            }} />
                                            <div style={{
                                                position: 'absolute',
                                                top: '8px',
                                                right: '8px',
                                                color: 'white',
                                                fontSize: '1.5rem',
                                                display: 'flex',
                                                zIndex: 6
                                            }}>
                                                {statusVisuals.icon}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="course-body" style={{
                                        backgroundColor: progreso === 100 ? '#f0fdf4' : '#ffffff',
                                        flex: 1,
                                        transition: 'background-color 0.3s ease'
                                    }}>
                                        <h3 className="course-title">{carrera.nombre || carrera.Nombre}</h3>
                                        <div style={{ marginTop: "0.8rem", flex: 1, display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                                            {/* Pills de Semestres y Cursos */}
                                            <div style={{
                                                fontSize: '0.8rem',
                                                backgroundColor: '#e0f2fe',
                                                color: '#0369a1',
                                                padding: '4px 12px',
                                                borderRadius: '9999px',
                                                fontWeight: 600,
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }}>
                                                <span>Semestres:</span>
                                                <span>{carrera.semestresTotales ?? carrera.SemestresTotales ?? 0}</span>
                                            </div>

                                            <div style={{
                                                fontSize: '0.8rem',
                                                backgroundColor: '#f1f5f9',
                                                color: '#475569',
                                                padding: '4px 12px',
                                                borderRadius: '9999px',
                                                fontWeight: 600,
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }}>
                                                <span>Cursos:</span>
                                                <span>{carrera.cursosTotales ?? carrera.CursosTotales ?? 0}</span>
                                            </div>

                                            {/* Instructor */}
                                            {(() => {
                                                const nombre = carrera.instructorNombre || carrera.InstructorNombre;
                                                if (!nombre) return null;
                                                return (
                                                    <div style={{
                                                        marginTop: '1rem',
                                                        color: '#1e293b',
                                                        fontWeight: '600',
                                                        fontSize: '0.9rem',
                                                        textAlign: 'center'
                                                    }}>
                                                        Instructor: {nombre}
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                        <div className="course-actions" style={{ marginTop: '1.5rem' }}>
                                            <button
                                                type="button"
                                                className="btn-action"
                                                style={{
                                                    width: '100%',
                                                    padding: '0.5rem 1rem',
                                                    cursor: 'pointer',
                                                    transition: '0.2s',
                                                    fontFamily: "'Outfit', sans-serif"
                                                }}
                                                onClick={() => handleOpenCarrera(carrera)}
                                            >
                                                Ver carrera
                                            </button>
                                        </div>
                                    </div>
                                </article>
                            );
                        })
                    )}
                </div>
            )}
        </div>
    );
}

export default MisCarreras;
